<div class="nav-container">
  <nav class="navbar navbar-expand-md navbar-light bg-light">
    <div class="container">
      <div class="navbar-brand logo rounded-circle"></div>
      <div class="in-context-entity">{{this.inContextEntityName}}</div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation"
        (click)="isCollapsed = !isCollapsed">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarNav" [ngbCollapse]="isCollapsed">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item">
            <a routerLink="/" class="nav-link">LTC</a>
          </li>
          @if ((auth.isAuthenticated$ | async) && isInMotorTwinContext() && appAccess.motortwin) {
          <li class="nav-item">
            <a routerLink="/motortwin" class="nav-link">MotorTwin</a>
          </li>
          <li class="nav-item">
            <a routerLink="jobs" class="nav-link">Jobs</a>
          </li>
          }
          @if ((auth.isAuthenticated$ | async) && isInMotorTwinContext() && appAccess.motortwin) {
          <li class="nav-item">
            <a routerLink="materials" class="nav-link">Materials</a>
          </li>
          }
          @if ((auth.isAuthenticated$ | async) && isInMotorTwinContext() && appAccess.motortwin) {
          <li class="nav-item">
            <a href="https://tinarmengineering.github.io/ltc-docs/" class="nav-link" target="_blank">Docs</a>
          </li>
          }
          @if ((auth.isAuthenticated$ | async) && isInFmedaContext() && appAccess.fmeda) {
          <li class="nav-item">
            <a routerLink="/fmeda" class="nav-link">FMEDA</a>
          </li>
          <li class="nav-item">
            <a routerLink="/projects" class="nav-link">Projects</a>
          </li>
          <li class="nav-item dropdown" ngbDropdown>
            <a class="nav-link dropdown-toggle" ngbDropdownToggle id="fmedaLibraryDropdown">Library</a>
            <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="fmedaLibraryDropdown">
              <a routerLink="/fmeda-workspace" [queryParams]="{ view: 'create', tab: 'component-types' }"
                class="dropdown-item">
                Component Types
              </a>
            </div>
          </li>
          }
          @if (this.taeUser && this.taeUser.level == 100) {
          <li class="nav-item">
            <a routerLink="organisations" class="nav-link admin-nav-link">Organisations</a>
          </li>
          <li class="nav-item">
            <a routerLink="messages" class="nav-link admin-nav-link">Messages</a>
          </li>
          <li class="nav-item">
            <a routerLink="clusters" class="nav-link admin-nav-link">Clusters</a>
          </li>
          <li class="nav-item">
            <a routerLink="logs" class="nav-link admin-nav-link">Logs</a>
          </li>
          }
        </ul>

        <ul class="navbar-nav d-none d-md-block">
          <!-- Login button: show if NOT authenticated -->
          @if ((auth.isAuthenticated$ | async) === false) {
          <li class="nav-item">
            <button id="qsLoginBtn" class="btn btn-primary btn-margin" (click)="loginWithRedirect()">
              Log in
            </button>
          </li>
          }
          <!-- / Login button -->


          <!-- Fullsize dropdown: show if authenticated -->
          @if (auth.user$ | async; as user) {
          <li class="nav-item dropdown" ngbDropdown>
            <a ngbDropdownToggle class="nav-link dropdown-toggle" id="profileDropDown" data-toggle="dropdown">
              <!-- Profile image should be set to the profile picture from the id token -->
              <img [src]="user.picture" alt="Profile picture" class="nav-user-profile rounded-circle"
                style="width: 75px;" />
            </a>
            <div class="dropdown-menu dropdown-menu-left" ngbDropdownMenu>
              <!-- Show the user's full name from the id token here -->
              <div class="dropdown-header">
                {{ user.name }}
              </div>
              <a routerLink="/profile" class="dropdown-item dropdown-profile">
                <!-- <fa-icon [icon]="faUser" class="mr-3"></fa-icon>-->Profile
              </a>
              @if (inContextOrg) {
              <a routerLink="/users" class="dropdown-item dropdown-profile">
                <!-- <fa-icon [icon]="faUsers" class="mr-3"></fa-icon>--> Users
              </a>
              }
              <button (click)="logout()" class="btn btn-link dropdown-item">
                <!-- <fa-icon [icon]="faPowerOff" class="mr-3"></fa-icon> -->Log out
              </button>
            </div>
          </li>
          }
          <!-- /Fullsize dropdown -->
        </ul>

        <!-- Responsive login button: show if NOT authenticated -->
        @if ((auth.isAuthenticated$ | async) === false) {
        <ul class="navbar-nav d-md-none">
          <button class="btn btn-primary btn-block" id="qsLoginBtn" (click)="loginWithRedirect()">
            Log in
          </button>
        </ul>
        }
        <!-- /Responsive login button -->

        <!-- Responsive profile dropdown: show if authenticated -->
        @if (auth.user$ | async; as user) {
        <ul class="navbar-nav d-md-none justify-content-between" style="min-height: 170px;">
          <li class="nav-item">
            <span class="user-info">
              <!-- Profile image should be set to the profile picture from the id token -->
              <img alt="Profile picture" class="nav-user-profile d-inline-block rounded-circle mr-3"
                style="width: 75px;" [src]="user.picture" />
              <!-- Show the user's full name from the id token here -->
              <h6 class="d-inline-block">{{ user.name }}</h6>
            </span>
          </li>
          <li>
            <!-- <fa-icon [icon]="faUser" class="mr-3"></fa-icon> -->
            <a routerLink="/profile">Profile</a>
          </li>
          <li>
            <!-- <fa-icon [icon]="faPowerOff" class="mr-3"></fa-icon> -->
            <button class="btn btn-link p-0" (click)="logout()">
              Log out
            </button>
          </li>
        </ul>
        }
      </div>
    </div>
  </nav>
</div>